import { render, staticRenderFns } from "./OnboardingTabs.vue?vue&type=template&id=2ff478ad"
import script from "./OnboardingTabs.vue?vue&type=script&lang=ts"
export * from "./OnboardingTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports